import MeasureType from "@/pages/takeoff/context/project-measure/models/measure-type.ts";
import rgbaToHexAndAlpha from "@/utils/colors/rgba-to-hex-and-alpha.ts";
import shouldConvertFromCentimetersToMeters from "@/pages/takeoff/layouts/measures/layouts/storey-measures/helpers";

interface EditMeasureTypeActionParams {
    measureType: MeasureType;
    formData: FormData;
}

interface EditMeasureTypeActionResult {
    success?: boolean;
    message?: string;
    updatedMeasureType?: MeasureType;
}

const editMeasureTypeAction = async ({measureType, formData}: EditMeasureTypeActionParams) : Promise<EditMeasureTypeActionResult> => {
    const name = (formData.get('name') as string || '').trim();
    const color = formData.get('color') as string;

    if (name === '' || !color) {
        return { message: 'Veuillez remplir tous les champs.' };
    }

    const { hex, alpha } = rgbaToHexAndAlpha(color);

    // On repart des dataInformations existantes pour ne pas perdre les clés non éditables (ex: offset).
    const dataInformations: Record<string, unknown> = {
        ...(measureType.dataInformations ?? {}),
        color: hex,
        alpha: alpha,
    };

    let allFieldsFilled = true;

    const dataInformationsFromMeasureType = measureType.dataInformations;
    if (measureType.dataFormatType && dataInformationsFromMeasureType) {
        Object.entries(measureType.dataFormatType)
            .filter(([key]) => key !== 'color' && key !== 'alpha')
            .forEach(([key, type]) => {
                if(dataInformationsFromMeasureType[key] == null) return;
                
                const val = formData.get(`dataFormatType_${key}`);

                if (typeof val !== 'string' || val.trim() === '') {
                    allFieldsFilled = false;
                    return;
                }

                if (type === 'number') {
                    let numVal = parseFloat(val);
                    if (shouldConvertFromCentimetersToMeters(key))
                        numVal /= 100;
                    dataInformations[key] = Number.isNaN(numVal) ? 0 : numVal;
                } else {
                    dataInformations[key] = String(val);
                }
            });
    }

    if (!allFieldsFilled) {
        return { message: 'Veuillez remplir tous les champs.' };
    }

    const updatedMeasureType = new MeasureType(
        measureType.measureTypeId,
        measureType.measureRepresentationId,
        measureType.measureShapeId,
        name,
        dataInformations,
        measureType.dataFormatType,
        measureType.dataFormatInstance
    );

    return { success: true, updatedMeasureType };
}

export default editMeasureTypeAction;
